import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MinutesToHHmmDurationPipe } from '@wilson/pipes';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { TranslateModule } from '@ngx-translate/core';
import { OvertimeIconPipe } from '../../pipes/overtime-icon.pipe';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
@Component({
  selector: 'wilson-overtime-value',
  imports: [
    CommonModule,
    MinutesToHHmmDurationPipe,
    NzTooltipModule,
    NzTypographyModule,
    OvertimeIconPipe,
    TranslateModule,
    NzSkeletonModule,
    FontAwesomeModule,
  ],
  templateUrl: './overtime-value.component.html',
  styleUrls: ['./overtime-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OvertimeValueComponent {
  @Input() overtimeInMinutes: number | null | undefined;
  @Input() isLoadingUsersOvertimes!: boolean;
}
